"use client"

import IconMinus from "@/app/(site)/_components/Atoms/Icons/IconMinus"
import IconPlus from "@/app/(site)/_components/Atoms/Icons/IconPlus"
import Text from "@/app/(site)/_components/Atoms/Text"
import React, { FC, useEffect, useRef, useState } from "react"

type AccordionProps = {
    elementId?: string
    label: string
    theme?: "light" | "dark"
    children: React.ReactNode
}

const CountryPickerAccordion: FC<AccordionProps> = ({
    elementId,
    label,
    theme = "dark",
    children
}) => {
    const [isOpen, setIsOpen] = useState(false) // Links is still visible in the DOM when closed
    const contentRef = useRef<HTMLDivElement>(null)
    const [maxHeight, setMaxHeight] = useState<string | number>("auto")

    useEffect(() => {
        if (contentRef.current) {
            setMaxHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px")
        }
    }, [isOpen])
    const handleClick = () => {
        setIsOpen(prev => !prev)
    }
    return (
        <>
            <button
                className="group flex w-full justify-between text-left"
                onClick={handleClick}
                aria-expanded={isOpen}
                aria-controls="language-list"
                id={elementId}
            >
                <Text
                    size="medium"
                    weight="regular"
                    className={`${theme === "light" ? "text-black" : "text-white"} md:transition-colors md:duration-200 md:group-hover:text-shades-80-white`}
                >
                    {label}
                </Text>
                {isOpen ? (
                    <IconMinus className="h-[24px] w-[24px]" />
                ) : (
                    <IconPlus className="h-[24px] w-[24px]" />
                )}
            </button>
            <div
                id={elementId ? elementId : ""}
                className={`flex flex-col overflow-hidden p-4 transition-[max-height,opacity] duration-300 ease-in-out ${
                    isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
                }`}
                style={{ maxHeight, opacity: isOpen ? 1 : 0 }}
                ref={contentRef}
                hidden={!isOpen}
            >
                {" "}
                {/* Adjust padding as needed */}
                {children}
            </div>
        </>
    )
}

export default CountryPickerAccordion
